import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdClose, MdLogin, MdPerson, MdPersonAdd } from 'react-icons/md';
import ThemeToggle from '../ThemeToggle';
import LanguageSelector from '../LanguageSelector';
import { t } from '../../utils/i18n';
import logoImage from '../../assets/babysit_logo.png';

export default function LandingHeader({ onOpenAuth }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleAuth = (mode) => {
    setIsMobileMenuOpen(false);
    onOpenAuth(mode);
  };

  return (
    <header className="landing-header sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-[4.25rem] flex justify-between items-center">
        <Link to="/" className="flex items-center gap-2.5 sm:gap-3 min-w-0">
          <img
            src={logoImage}
            alt="Nannity Logo"
            className="h-9 sm:h-10 w-auto flex-shrink-0"
          />
          <span className="text-lg sm:text-xl font-bold gradient-bg bg-clip-text text-transparent truncate">
            Nannity
          </span>
          <span className="hidden lg:inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium border landing-header-badge">
            {t('landing.header.badge')}
          </span>
        </Link>

        <div className="hidden md:flex gap-1.5 sm:gap-2 items-center">
          <LanguageSelector />
          <ThemeToggle />
          <button
            type="button"
            onClick={() => onOpenAuth('login')}
            className="landing-btn-ghost px-3.5 py-2 text-sm font-semibold rounded-xl transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40"
          >
            {t('landing.header.login')}
          </button>
          <button
            type="button"
            onClick={() => onOpenAuth('register')}
            className="btn-primary text-sm px-5 py-2.5"
          >
            {t('landing.header.register')}
          </button>
        </div>

        <div className="md:hidden flex items-center gap-1.5">
          <LanguageSelector />
          <button
            type="button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="p-2 rounded-xl landing-mobile-menu-btn transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40"
            aria-label={t('nav.accountMenu')}
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? (
              <MdClose className="text-xl" />
            ) : (
              <MdPerson className="text-xl" />
            )}
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden border-t landing-header-mobile-menu">
          <div className="max-w-7xl mx-auto px-4 py-3 space-y-1">
            <div className="flex items-center justify-between py-2 px-3 rounded-xl landing-mobile-menu-item">
              <span className="text-sm font-medium text-[var(--color-text-muted)]">
                {t('nav.theme')}
              </span>
              <ThemeToggle />
            </div>
            <button
              type="button"
              onClick={() => handleAuth('register')}
              className="flex items-center justify-between gap-3 w-full px-3 py-2.5 rounded-xl font-semibold border-2 border-olive-600/80 text-olive-700 dark:text-olive-300 hover:bg-olive-50/80 dark:hover:bg-olive-900/20 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-olive-500/40"
            >
              <span>{t('nav.startFree')}</span>
              <MdPersonAdd className="text-xl flex-shrink-0" />
            </button>
            <button
              type="button"
              onClick={() => handleAuth('login')}
              className="flex items-center justify-between gap-3 w-full btn-primary px-3 py-2.5 rounded-xl"
            >
              <span>{t('landing.header.login')}</span>
              <MdLogin className="text-xl opacity-90 flex-shrink-0" />
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
